import * as React from "react";
import { SagaIterator } from "redux-saga";
import { select } from "typed-redux-saga";

import { Activity } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { EntityInstancePath } from "@com.mgmtp.a12.kernel/kernel-md-facade";

import { getFVManifest } from "../app/slices/fachverfahren/selectors";
import { ConfigurationValue, MappingElement } from "../app/slices/fachverfahren/types";
import { ActivityContext } from "../modules/processFormEngine/components/contexts";

/**
 * Holt den zu einer modulf_AliasForPath Annotation gehörenden Pfad aus dem Fachverfahrens-Manifest.
 * @param aliasForPath Name des Alias der aufgelöst werden soll. Nur bei einzigartigen Aliasen verwenden!
 * @param activity
 */
export function* getPathFromFVManifest(aliasForPath: string, activity: Activity): SagaIterator<EntityInstancePath> {
	if (!activity.descriptor.fachverfahren) {
		throw new Error(
			`Der Activity-Descriptor für ${activity.id} enthält keine Fachverfahren-ID: ${JSON.stringify(
				activity.descriptor
			)}`
		);
	}
	const fvManifest = yield* select(getFVManifest(activity.descriptor.fachverfahren));
	const path = fvManifest?.mappingElement.find((x: MappingElement) => x.alias == aliasForPath)?.path;

	if (!path) {
		throw new Error(
			`Es sind keine Konfigurationspfade für das Fachverfahren ${activity.descriptor.fachverfahren} und alias: ${aliasForPath} vorhanden.`
		);
	}

	return path;
}

/**
 * Holt den zu einem Configuration-Key gehörigen Wert aus dem Fachverfahrens-Manifest.
 * @param key Configuration-Key
 */
export function useConfigValueFromFVManifest(key: string): string {
	const fvInfo = React.useContext(ActivityContext)?.fvManifest;
	const value = fvInfo?.configurationValues?.find((x: ConfigurationValue) => x.key == key)?.value;

	if (value === undefined || value === null) {
		throw new Error(
			`Der gesuchte Konfigurationswert ${key} konnte im Fachverfahren-Manifest ` + "nicht gefunden werden."
		);
	}
	return value;
}
